import Migrate from "../../assets/migrate.svg?react"
import Bond from "../../assets/bond.svg?react"
import OldWallet from "../../assets/old_wallet.svg?react"
import { useI18nContext } from "../../i18n/i18n-react"
import clsx from "clsx"
import { Link, Outlet } from "react-router-dom"
import { Suspense } from "react"
import { FullSpinner } from "../../components/common/Spinner"
import { useIsAdmin } from "../../services/hook"

type Type = "migration" | "bonds" | "admin"

const NavItem = ({ children, title, value, current, to }: { children: React.ReactNode; title: string; value?: Type; current: Type; to: string }) => {
  return (
    <Link to={to} className={clsx("flex flex-col space-y-1 items-center w-full pt-4 pb-5", value === current ? " text-[#222222]" : " text-[#B8BDC7]")}>
      {children}
      <div className="text-xs">{title}</div>
    </Link>
  )
}

export const HomeLayout = ({ type }: { type: Type }) => {
  const { LL } = useI18nContext()
  const isAdmin = useIsAdmin()

  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-col grow h-full overflow-hidden">
        <Suspense fallback={<FullSpinner />}>
          <Outlet />
        </Suspense>
      </div>

      <nav className="shrink flex flex-row justify-around shadow-[0px_-4px_34px_0px_rgba(75,124,221,0.10)]">
        <NavItem title={LL.migration()} value="migration" current={type} to="/">
          <Migrate />
        </NavItem>
        <NavItem title={LL.myBonds()} value="bonds" current={type} to="/bonds">
          <Bond />
        </NavItem>
        <NavItem title={isAdmin ? "Admin" : LL.oldWallet()} value={isAdmin ? "admin" : undefined} current={type} to={isAdmin ? "/admin" : "https://mixinwallet.com/"}>
          <OldWallet />
        </NavItem>
      </nav>
    </div>
  )
}
